
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'settings': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.454 20',
    data: '<path pid="0" d="M17.159 10.98a7.793 7.793 0 0 0 .07-.98 7.793 7.793 0 0 0-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.306 7.306 0 0 0-1.69-.98l-.38-2.65a.488.488 0 0 0-.49-.42h-4a.488.488 0 0 0-.49.42l-.38 2.65a7.684 7.684 0 0 0-1.69.98l-2.49-1a.488.488 0 0 0-.61.22l-2 3.46a.493.493 0 0 0 .12.64l2.11 1.65a7.931 7.931 0 0 0-.07.98 7.931 7.931 0 0 0 .07.98l-2.11 1.65a.5.5 0 0 0-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1a7.306 7.306 0 0 0 1.69.98l.38 2.65a.488.488 0 0 0 .49.42h4a.488.488 0 0 0 .49-.42l.38-2.65a7.683 7.683 0 0 0 1.69-.98l2.49 1a.488.488 0 0 0 .61-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65zm-7.43 2.52a3.5 3.5 0 0 1-3.5-3.5 3.5 3.5 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
